import React, { useEffect, useState } from "react";
import styles from "./meetingtranscript.module.scss";
import { Dropdown, Form, Menu, Modal, Popover, Radio, Select, Tooltip } from "antd";
import { URInputwithLabel } from "../../../../../shared/widgets/inputwithLable";
import { URAvatarGroup } from "../../../../../shared/widgets/avatarGroup";
import { URStatusDot } from "../../../../../shared/widgets/avatarGroup/statusDot";
import store from "../../../../../context/store/store";
import { searchHandler, searchHighlight, searchTranscriptHighlight, toastInformation, userStatusColor } from "../../../../../base/callService/common";
import moment from 'moment';
import jsPDF from "jspdf";
import _ from "lodash";
import { URInput } from "../../../../../shared/widgets/input";
import { useSelector } from "react-redux";
import { storeTranscript } from "../../../../../base/callService/asrTTS";
import Lottie from "lottie-react";
import ContactLoader from "../../../../../styles/images/Lottie Animation.json";
// import React from "react";
// import { URCheckBox } from "../../../../shared/widgets/checkbox";
type MeetingTranscript = {
  download: any;
  allContacts: any;
  favouriteContacts: any;
  searchKey: string;
  shareUrl: string;
  shareContact: any;
  editModal: boolean;
  isShareModal: Boolean;
  isDownloadModal: boolean;
  transcriptData:Array<any>;
};


export default function MeetingTranscript() {
  let { contactReducer }: any = useSelector((state: any) => state);
  let { detailPage, transcript,searchKey, momLoad, part_MOM } = store.getState().meetingReducer;
  let { workContacts, favContacts } = contactReducer;
  const [index, setIndex] = useState(0);
  const [search,setSearch]=useState("");
  const [getData, setData] = useState<MeetingTranscript>({
    download: "", allContacts: workContacts, favouriteContacts: favContacts, searchKey: "", shareUrl: "", shareContact: [],
    editModal: false, isShareModal: false, isDownloadModal: false,transcriptData:transcript
  });
  // useEffect(() => {
  //   var focusableInputElements: any = document.querySelectorAll(".highlight1");
  //   setIndex(0);
  //   if (focusableInputElements?.length > 0) {
  //     debounce_fun();
  //   }
  //   document.addEventListener("keydown", keyDownEvent);
  //   return () =>  document.removeEventListener("keydown", keyDownEvent);
  // }, [JSON.stringify(detailPage.uuid), searchText])

  const keyDownEvent=(e:any)=>{
    console.log(e.keyCode);
    
if(e.keyCode === "ArrowDown"){
  downMove(e);
}
else if(e.keyCode ==="ArrowUp"){
  upMove(e);
}
  }
  var debounce_fun = _.debounce(function () {
    var focusableInputElements: any = document.querySelectorAll(".highlight1");
    if (focusableInputElements?.length > 0) {
      focusableInputElements[0].focus();
      focusableInputElements[0].style.backgroundColor = "#B3D7FA";
      focusableInputElements[0].style.borderBottom = "1px solid #68AFF5";
      var inn: any = document.getElementById('inputBox')
      inn?.focus();
    }
    console.log('Function debounced after 1000ms!');
  }, 1000);

  useEffect(()=>{
    // setData({...getData,searchKey:searchKey});
    setSearch(searchKey);
    searchTrancript(searchKey);
    },[searchKey])

    useEffect(()=>{
      setData({ ...getData, transcriptData: transcript });
    },[transcript])

    const searchTrancript=(text:any)=>{
      if (text !== "") {
        let filtered = _.filter(transcript, function (elem: any) {
          return elem.text?.toLowerCase().includes(text.toLowerCase()) || elem.name?.toLowerCase().includes(text.toLowerCase())
        });
        
        setData({ ...getData, transcriptData: filtered });
    }
    else {
      setData({ ...getData, transcriptData: transcript });
    }
    }


  const upMove = (e: any) => {
    let downCountRes: number = index - 1;
    if (index !== 0) {
      var focusableInputElements: any = document.querySelectorAll(".highlight1");
      if (focusableInputElements) {
        let nextIndex = downCountRes;
        e.preventDefault();
        nextIndex = downCountRes;
        focusableInputElements[nextIndex].focus();
        focusableInputElements[nextIndex].style.backgroundColor = "#B3D7FA";
        focusableInputElements[nextIndex].style.borderBottom = "1px solid #68AFF5";
        focusableInputElements[nextIndex + 1].style.backgroundColor = "#FBF4C5";
        focusableInputElements[nextIndex + 1].style.borderBottom = "1px solid #FBE880";
        setIndex(downCountRes);
      }
    }
  }

  const downMove = (e: any) => {

    let downCountRes: number = index + 1;
    if (downCountRes < transcript.length) {
      var focusableInputElements: any = document.querySelectorAll(".highlight1");
      if (focusableInputElements) {
        let nextIndex = downCountRes;
        e.preventDefault();
        nextIndex = downCountRes;
        focusableInputElements[nextIndex].focus();
        focusableInputElements[nextIndex].style.backgroundColor = "#B3D7FA";
        focusableInputElements[nextIndex].style.borderBottom = "1px solid #68AFF5";
        focusableInputElements[nextIndex - 1].style.backgroundColor = "#FBF4C5";
        focusableInputElements[nextIndex - 1].style.borderBottom = "1px solid #FBE880";
        setIndex(downCountRes)
      }
    }
  }



  let len = Math.round((getData.transcriptData?.length / 8)) > 0 ? getData.transcriptData?.length : 1;
  let random_color = Array(len).fill([1, 2, 3, 4, 5, 6, 7, 8]).flat();

  return (
    <>

      <div className={styles.tabsubinnerconsecmain}>

       

          <div className={styles.summarydetailssec}>
            <div className={styles.summarydetailinnermiddle}>
              <div className={styles.middlemainconsec}>
                {getData.transcriptData && getData.transcriptData.map((elem: any, i: any) => {
                  let searchh: any = searchTranscriptHighlight(elem, search)
                  return (

                    <div className={styles.profilelists} key={i} id='transs'>
                      <div>
                        <URAvatarGroup className={`lefts size32 colorBG${random_color[i]}`}
                          profileInfo={<><span>{elem.name.toUpperCase().charAt(0)}</span><URStatusDot className='stsDotsm green' /></>} />
                      </div>
                      <div className={styles.middle}>
                        <h4>{elem.name}<span>{moment(elem.time).format("hh:mm A")}</span></h4>
                        {(searchh?.middleMsg !== "" && search !== "") ?
                          <p>{searchh?.firstMsg}
                            < span className={'highlight1'} tabIndex={index}>{searchh?.middleMsg}</span>{searchh?.lastMsg}</p> : (getData.searchKey  !== "" && searchh?.middleMsg === "") ?
                            <p>{elem.text}</p> : <><p>{elem.text}</p></>}
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>
          </div>
          {
            (part_MOM?.length === 0) && !momLoad && <div className={styles.middlemainconsec}>
              <h4></h4>
              <p className={styles.nodatafound}>No Data Found</p>
            </div>
          }
          {
            part_MOM?.length === 0 && momLoad &&
            <div ><Lottie className="svgLoadinglistcenter" animationData={ContactLoader} /></div>
          }
      </div>
    </>
  );
};

